<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="col-lg-12">
                <div style="border: none; border-radius: 10px;text-align:center"
                     class="panel panel-default country-select-panel">
                    <div class="panel-body">
                        <h3>{{ $t("ui.selectSurvey") }}</h3>
                        <hr>
                        <spinner></spinner>
                        <div class="col-md-12 text-left" style="margin-bottom:10px;">
                            <button v-on:click="makeLogout(companyUid)" type="button" class="btn btn-success"
                                    v-bind:style="{ background: $store.getters.getButtonColor}">{{ $t("ui.logout") }}({{
                                $store.getters.getUsername }})
                            </button>
                        </div>
                        <div class="col-md-12">
                            <table class="table table-hover">
                                <tbody>
                                <tr v-for="survey in survey_list" v-bind:key="survey.survey_location_access_uid">
                                    <td>
                                        <router-link
                                                :to="{ name: 'Survey', params: { uid: survey.survey_location_access_uid }}">
                                            <h3>{{ survey.title }}</h3>
                                        </router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import Spinner from '../ui/Spinner'

    export default {
        name: 'cabinet',
        data() {
            return {
                survey_list: [],
                background: '',
                companyUid: ''
            }
        },
        mounted() {

            this.$store.dispatch('SURVEY_LIST').then(() => {
                this.getQuestionnaireList()
            });

            this.companyUid = this.$store.getters.getCompanyUid;
        },
        methods: {
            getQuestionnaireList: function () {
                this.survey_list = this.$store.getters.surveyList;
            },
            makeLogout: function (companyUid) {

                this.$store.dispatch('AUTH_LOGOUT').then(() => {
                    this.$router.push({
                        name: 'Login', params:
                            {
                                uid: companyUid
                            }
                    });
                })
            }
        },
        components: {
            Spinner
        }
    }
</script>
